export default "__VITE_ASSET__0VElno0B__"